import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'
import { useAccount } from 'wagmi';
import { ConnectButton } from '@rainbow-me/rainbowkit';

const Home = () => {

    const { isConnected } = useAccount();
    const [ classSet, setClassSet ] = useState('initial');

    return (
        <>

            <h1 className="title">
                    <Link to="/">Web3</Link>
            </h1>

            <motion.div className="container"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >

                <main className="main">

                    <div className="content">

                        <div className="page-content">

                            <div className="grid">

                                <div className="card flx ctr-xy">

                                {isConnected ?
                                    <>
                                    <Link to="/token">
                                        <h2>Web3 &rarr;</h2>
                                    </Link>
                                    
                                    <Link to="/token">
                                        <p>Learn about Web3.</p>
                                    </Link>
                                    </>
                                :
                                    <div className=""><ConnectButton /></div>
                                }
                                </div>

                                <a href="https://opensea.io/" className="card" target="_blank" rel="noreferrer noopener">
                                    <h2>Web3 NFT&apos;s &rarr;</h2>
                                    <p>Learn about our upcoming NFT&apos;s.</p>
                                </a>

                            </div>
                        
                        </div>

                    </div>

                </main>

            </motion.div>
        </>
    );
}

export default Home
